function snakeCaseToReadable(from: string): string {
    return from.split('_').join(' ');
}

export default snakeCaseToReadable;
